export const numberToCurrency = (number) => {
  if (number === null || number === undefined) return '';

  return number.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  });
};

export const adjustValue = (value, percentage, decimalPlaces = 0) => {
  const valueAdjusted = value * (1 + (percentage / 100));
  const valueRounded = Math.round(valueAdjusted * 10 ** decimalPlaces) / 10 ** decimalPlaces;
  return valueRounded;
};

export const normalizeTextForSearch = (text) => {
  if (!text) return '';
  if (typeof text !== 'string') return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '');
};

export function convertToSlug(text) {
  const a = 'àáäâãèéëêìíïîòóöôõùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·_:&';
  const b = 'aaaaaeeeeiiiiooooouuuuncsyoarsnpwgnmuxzh---e';
  const p = new RegExp(a.split('').join('|'), 'g');
  return text.toString().toLowerCase().trim()
    .replace(p, (c) => b.charAt(a.indexOf(c)))
    .replace(/[\s\W-]+/g, '-');
}

export const objectToFormattedString = (obj) => {
  if (!obj || typeof obj !== 'object') return '';

  const formattedString = Object.entries(obj)
    .map(([key, value]) => {
      // Converte a chave para o formato kebab-case
      const formattedKey = key
        .replace(/([A-Z])/g, '-$1')
        .toLowerCase()
        .replace(/^-/, '');

      // Converte o valor para string e normaliza
      let formattedValue = value;
      if (value === null || value === undefined) {
        formattedValue = '';
      } else if (typeof value === 'string') {
        formattedValue = value.toLowerCase();
      } else if (value instanceof Date) {
        formattedValue = value.toISOString();
      } else {
        formattedValue = String(value).toLowerCase();
      }

      return `${formattedKey}-${formattedValue}`;
    })
    .join('-');

  return convertToSlug(formattedString);
};

export const generateQueryString = (obj) => {
  const query = new URLSearchParams();
  Object.entries(obj).forEach(([key, value]) => {
    query.append(key, value);
  });
  return query.toString();
};

export const objectToFieldValueArrayString = (obj) => {
  if (!obj || typeof obj !== 'object') return '[]';

  const fieldValueArray = Object.entries(obj).map(([field, value]) => ({
    field,
    value,
  }));

  return JSON.stringify(fieldValueArray);
};
